import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { comparison } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-sand py-16 sm:py-20" aria-labelledby="compare-heading" data-id="element-21" data-mp="69ms461iyo2a">
      <div className="mx-auto max-w-5xl px-5" data-id="element-22" data-mp="3oeztfw34q3gu">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-23" data-mp="3shcysjdyrzd3">
          Before vs. after
        </p>
        <h2 id="compare-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso sm:text-4xl" data-id="element-24" data-mp="3eponujfgbgxp">
          Stop improvising. Start working from a system.
        </h2>

        <div className="mt-10 overflow-hidden rounded-2xl border border-espresso/10" data-id="element-25" data-mp="34ppbscjtp8g3">
          <div className="grid grid-cols-2" data-id="element-26" data-mp="39reri5hzqaai">
            <p className="bg-cocoa px-6 py-4 font-sans text-[11px] font-bold uppercase tracking-[0.14em] text-cream/70" data-id="element-27" data-mp="2vrccqs4zbwzh">
              Without the Bible
            </p>
            <p className="bg-espresso px-6 py-4 font-sans text-[11px] font-bold uppercase tracking-[0.14em] text-goldlight" data-id="element-28" data-mp="30s9oomzebusj">
              With the Bible
            </p>
          </div>
          {comparison.map(row => <div key={row.before} className="grid grid-cols-2 border-t border-espresso/10" data-id="element-29" data-mp="172hqfje75mxb">
              <div className="flex items-start gap-3 bg-cream px-6 py-5" data-id="element-30" data-mp="124om6vwgf2zo">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-31" data-mp="edj5keiow6ob" />
                <p className="font-sans text-sm leading-relaxed text-muted" data-id="element-32" data-mp="o3vo616y1prt">
                  {row.before}
                </p>
              </div>
              <div className="flex items-start gap-3 border-l border-espresso/10 bg-cream px-6 py-5" data-id="element-33" data-mp="jc44mam7gkb6">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-34" data-mp="3rrnwb5789uo4" />
                <p className="font-sans text-sm font-semibold leading-relaxed text-espresso" data-id="element-35" data-mp="1qrj0rk6twlpm">
                  {row.after}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}